import { InitOptions, SpaceApi } from '@usersnap/browser';
import React, { useContext, useState } from 'react';
import { getUsersnapConfig, UsersnapConfig } from '../config';
// import { checkPermission } from '../api/Network';

type UserSnapContextType = {
  usersnapApi?: SpaceApi;
  openUsersnap: () => void;
  showUsersnap: boolean;
};
export const UsersnapContext = React.createContext<UserSnapContextType>({
  showUsersnap: false,
  openUsersnap: () => console.error('usersnap not initialized'),
});

export const UsersnapProvider = ({ initParams, children }: UsersnapProviderProps) => {
  const [usersnapApi, setUsersnapApi] = useState<SpaceApi | undefined>();
  const [showUsersnap, setShowUsersnap] = useState<boolean>(false);

  const openUsersnap = () => {
    getUsersnapConfig().then((config: UsersnapConfig) => {
      usersnapApi?.show(config.projectApiKey).then((widgetApi) => widgetApi.open({}));
    });
  };
  // useEffect(() => {
  //   getUsersnapConfig().then((config: UsersnapConfig) => {
  //     loadSpace(config.globalApiKey).then((api: SpaceApi) => {
  //       api.init(initParams);
  //       setUsersnapApi(api);
  //     });
  //   });
  //   checkPermission('Usersnap').then((hasPermission) => {
  //     console.log(hasPermission);
  //     setShowUsersnap(hasPermission);
  //   });
  // }, [initParams]);

  return (
    <UsersnapContext.Provider value={{ usersnapApi, openUsersnap, showUsersnap }}>{children}</UsersnapContext.Provider>
  );
};

interface UsersnapProviderProps {
  initParams?: InitOptions;
  children: React.ReactNode;
}

export function useUsersnapApi() {
  return useContext(UsersnapContext);
}
